import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';
import mainClasses from '../../../pages/Main/Main.module.scss';
import classes from './SkeletonMainTopSlider.module.scss';
import Skeleton from '../Skeleton';

export default function SkeletonMainTopSlider() {
  const cards = [1, 2, 3, 4];

  return (
    <div className={mainClasses.topSliderBox}>
      <Swiper
        className={mainClasses.topSlider}
        modules={[FreeMode]}
        spaceBetween={33}
        slidesPerView='auto'
        loop
        freeMode
        breakpoints={{
          0: {
            spaceBetween: 20,
            freeMode: true,
          },
          992: {
            spaceBetween: 33,
            freeMode: false,
          },
        }}
      >
        {cards.map((_, index) => (
          <SwiperSlide className={mainClasses.topSlide} key={index}>
            <div className={`${mainClasses.topSlideItem} ${classes.topSlideItem}`}>
              <div className={mainClasses.topSlideItemImg}>
                <Skeleton borderRadius='5px' width='100%' height='100%' isLight />
              </div>
              <div className={mainClasses.topSlideItemDesc}>
                <div className={mainClasses.topSlideItemTitle}>
                  <div className={classes.title}>
                    <Skeleton borderRadius='5px' width='100%' height='100%' isLight={false} />
                  </div>
                  <div className={classes.title}>
                    <Skeleton borderRadius='5px' width='100%' height='100%' isLight={false} />
                  </div>
                </div>
                <div className={mainClasses.topSlideItemPlace}>
                  <div className={classes.place}>
                    <Skeleton borderRadius='5px' width='100%' height='100%' isLight={false} />
                  </div>
                  <Skeleton borderRadius='5px' width='100%' height='100%' isLight={false} />
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
